import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export const exportElement = async (element, type = 'image', filename = 'export') => {
  if (!element) {
    console.error('Export tool: Element not found');
    return;
  }

  try {
    const canvas = await html2canvas(element, { scale: 2, useCORS: true }); // high-res
    const imgData = canvas.toDataURL('image/png');

    if (type === 'image') {
      const link = document.createElement('a');
      link.href = imgData;
      link.download = `${filename}_${Date.now()}.png`;
      link.click();
    } else if (type === 'pdf') {
      const pdf = new jsPDF('landscape');
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      pdf.save(`${filename}_${Date.now()}.pdf`);
    }
  } catch (error) {
    console.error('Export failed:', error);
  }
};
